import React, { useState, useEffect, useRef } from 'react';
import { Plane, Hotel, Car, Ship, Backpack, Bus, ArrowLeftRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from "axios"

const HeroSection = () => {
  const [activeTab, setActiveTab] = useState('Tour');
  const [tripType, setTripType] = useState('Same drop-off');
 const [tourType, setTourType] = useState([]);
 const [cabType, setCabType] = useState([])
 const [selectedTourType, setSelectedTourType] = useState(null);
 const [selectedCabType, setSelectesCabType] = useState(null)
const [isDropdownOpen, setIsDropdownOpen] = useState(false);
const [tourNameById, setTourNameById] = useState(null)
const dropdownRef = useRef(null);
const [selectedTourName, setSelectedTourName] = useState(null);
const [isTourNameDropdownOpen, setIsTourNameDropdownOpen] = useState(false);
const tourNameDropdownRef = useRef(null);
const [travellersOpen, setTravellersOpen] = useState(false);
const [adults, setAdults] = useState(1);
const [children, setChildren] = useState(0);
const travellersRef = useRef(null);
const [isCabDropdownOpen, setIsCabDropdownOpen] = useState(false);
const cabDropdownRef = useRef(null);
const [cabNameList, setCabNameList] = useState([]);
const [selectedCabName, setSelectedCabName] = useState(null);
const [isCabNameDropdownOpen, setIsCabNameDropdownOpen] = useState(false);
const cabNameDropdownRef = useRef(null);


  const fetchToursTypeData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/tour-types/get-all`,
      );
      setTourType(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchToursTypeData();
  }, []);

  const fetchCabTypeData = async () => {
    try {
      const response = await axios.get( `${process.env.REACT_APP_API_URL}/cab/stats/overview`)
      setCabType(response?.data?.data?.byType)
      console.log("cab", response);
      
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchCabTypeData()
  },[])

  const fetchCabNameByType = async (type) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/cab/type/${type}`
    );

    setCabNameList(response.data.data);
  } catch (error) {
    console.log(error);
  }
};

//   useEffect(() => {
//   const handleClickOutside = (event) => {
//     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//       setIsDropdownOpen(false);
//     }
//   };

//   document.addEventListener("mousedown", handleClickOutside);
//   document.addEventListener("touchstart", handleClickOutside);
//   return () => {
//     document.removeEventListener("mousedown", handleClickOutside);
//     document.removeEventListener("touchstart", handleClickOutside);
//   };
// }, []);

const fetchTourNameById = async (id) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/tour-details/get-tour-by-tourtype/${id}`)
    setTourNameById(response.data)
    
    console.log("tourtype", response);
    
  } catch (error) {
    console.log(error);
    
  }
}


useEffect(() => {
  const handleClickOutside = (event) => {

    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }

    if (tourNameDropdownRef.current && !tourNameDropdownRef.current.contains(event.target)) {
      setIsTourNameDropdownOpen(false);
    }

     if (travellersRef.current && !travellersRef.current.contains(event.target)) {
      setTravellersOpen(false);
    }
    if (cabDropdownRef.current && !cabDropdownRef.current.contains(event.target)) {
  setIsCabDropdownOpen(false);
}

if (
  cabNameDropdownRef.current &&
  !cabNameDropdownRef.current.contains(event.target)
) {
  setIsCabNameDropdownOpen(false);
}

  };

  document.addEventListener("mousedown", handleClickOutside);
  document.addEventListener("touchstart", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
    document.removeEventListener("touchstart", handleClickOutside);
  };
}, []);


  const tabs = [
 
      { name: 'Tour', icon: Backpack },
      { name: 'Cars', icon: Car },
      {name: 'Hotels', icon: Hotel },
  ];

  const navigate = useNavigate()

  return (
    <div className="relative h-auto w-full pt-20">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center h-full w-full"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1557323137-bd6bd20fe022?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2FyJTIwaW4lMjBuYXR1cmV8ZW58MHx8MHx8fDA%3D')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/30 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto p-8 lg:pt-20  px-4 sm:px-8 lg:px-20">
        {/* Hero Heading */}
        <div className="mb-8">
          <h1 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4 lg:mb-6">
            Rent Luxury Cars on the
            <br />
            Lowest Price
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-white/95 max-w-2xl">
            Your ultimate destination for all things help you celebrate & remember tour experience.
          </p>
        </div>

        {/* Booking Card */}
        <div className="bg-white rounded-xl shadow-xl p-6 ">
          {/* Service Tabs */}
          <div className="flex flex-wrap gap-2 mb-4">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.name;
              return (
                <button
                  key={tab.name}
                  onClick={() => setActiveTab(tab.name)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full font-medium text-[14px] transition-all ${
                    isActive
                      ? 'bg-red-500 text-white shadow-lg'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  <Icon className="w-[18px] h-[18px]" />
                  <span>{tab.name}</span>
                </button>
              );
            })}
          </div>

            {activeTab === "Cars" && ( 
              <>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-end mb-6">
            {/* From Location */}
           <div className="lg:col-span-4" ref={cabDropdownRef}>
  <label className="block text-sm font-medium text-gray-600 mb-2">
    Cab Type
  </label>

  <div className="relative">

    {/* Selected Value */}
    <div
      onClick={() => setIsCabDropdownOpen(!isCabDropdownOpen)}
      className="w-full border border-gray-300 rounded-xl px-4 py-2 cursor-pointer bg-white flex justify-between items-center"
    >
      <span className="text-gray-700">
        {selectedCabType ? selectedCabType : "Select Cab Type"}
      </span>

      <span className="text-gray-400">▼</span>
    </div>

    {/* Dropdown */}
    {isCabDropdownOpen && (
      <div className="absolute left-0 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-lg max-h-60 overflow-y-auto z-50">

        {cabType?.map((type) => (
          
          <div
            key={type?._id}
            onClick={() => {
              setSelectesCabType(type?._id);
              setIsCabDropdownOpen(false);
              fetchCabNameByType(type?._id);
            }}
            className="px-4 py-2 hover:bg-red-200 cursor-pointer text-gray-700 capitalize"
          >
            {type?._id}
          </div>
        ))}
      </div>
    )}
  </div>
</div>


           
            {/* To Location */}
            <div className="lg:col-span-3" ref={cabNameDropdownRef}>
  <label className="block text-sm font-medium text-gray-600 mb-2">
    Cab Name
  </label>

  <div className="relative">

    {/* Selected Cab */}
    <div
      onClick={() => setIsCabNameDropdownOpen(!isCabNameDropdownOpen)}
      className="w-full border border-gray-300 rounded-xl px-4 py-2 cursor-pointer bg-white flex justify-between items-center"
    >
      <span className="text-gray-700">
        {selectedCabName ? selectedCabName?.name : "Select Cab"}
      </span>

      <span className="text-gray-400">▼</span>
    </div>

    {/* Dropdown */}
    {isCabNameDropdownOpen && (
      <div className="absolute left-0 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-lg max-h-60 overflow-y-auto z-50">

        {cabNameList?.map((cab) => (
          <div
            key={cab?._id}
            onClick={() => {
              setSelectedCabName(cab);
              setIsCabNameDropdownOpen(false);
            }}
            className="px-4 py-2 hover:bg-red-200 cursor-pointer text-gray-700 capitalize"
          >
            {cab?.name}
          </div>
        ))}

      </div>
    )}

  </div>
</div>

            <div className="lg:col-span-2" ref={travellersRef}>
  <label className="block text-sm font-medium text-gray-600 mb-2">
    Travellers
  </label>

  <div className="relative">

    {/* Input Box */}
    <div
      onClick={() => setTravellersOpen(!travellersOpen)}
      className="w-full border border-gray-300 rounded-xl px-4 py-2 cursor-pointer bg-white flex justify-between items-center"
    >
      <span>
        {adults + children} Traveller{adults + children > 1 && "s"}
      </span>

      <span className="text-gray-400">▼</span>
    </div>

    {/* Dropdown */}
    {travellersOpen && (
      <div className="absolute left-0 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-lg p-4 space-y-4 z-50">

        {/* Adults */}
        <div className="flex justify-between items-center">
          <span className="text-gray-700">Adults</span>

          <div className="flex items-center gap-3">

            <button
              onClick={() => adults > 1 && setAdults(adults - 1)}
              className="w-7 h-7 border rounded flex items-center justify-center"
            >
              -
            </button>

            <span>{adults}</span>

            <button
              onClick={() => setAdults(adults + 1)}
              className="w-7 h-7 border rounded flex items-center justify-center"
            >
              +
            </button>

          </div>
        </div>

        {/* Children */}
        <div className="flex justify-between items-center">
          <span className="text-gray-700">Children</span>

          <div className="flex items-center gap-3">

            <button
              onClick={() => children > 0 && setChildren(children - 1)}
              className="w-7 h-7 border rounded flex items-center justify-center"
            >
              -
            </button>

            <span>{children}</span>

            <button
              onClick={() => setChildren(children + 1)}
              className="w-7 h-7 border rounded flex items-center justify-center"
            >
              +
            </button>

          </div>
        </div>

      </div>
    )}

  </div>
</div>

            {/* Departure Date */}
            <div className="lg:col-span-2">
              <label className="block text-sm font-medium text-gray-600 mb-2">
                Date
              </label>
              <div className="relative">
                <input
                  type='date'
                  defaultValue="21-10-2024"
                  className="w-full px-4 py-2 text-[15px] font-semibold text-gray-900 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none"
                />
                <div className="absolute right-4 top-1/2 -translate-y-1/2 text-xs text-gray-400 font-medium">
                
                </div>
              </div>
            </div>
            {/* Search Button */}
            <div className="lg:col-span-1">
              <button onClick={() => navigate("/car")} className="w-full px-6 py-2 bg-red-500 hover:bg-white text-white hover:text-red-500 border border-red-500 duration-300 font-semibold text-[15px] rounded-xl transition-all shadow-lg hover:shadow-xl">
                Search
              </button>
            </div>
          </div>
          </>
        )}
          {/* Trip Type Options */}
         

          {/* Booking Form */}
          
        {/* Booking Card */}
        {activeTab === "Tour" && ( 
       
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-end mb-6">
            {/* From Location */}
            <div className="lg:col-span-4" ref={dropdownRef}>
  <label className="block text-sm font-medium text-gray-600 mb-2">
    Tour Type
  </label>

  <div className="relative">
    {/* Selected value */}
    <div
      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      className="w-full border border-gray-300 rounded-xl px-4 py-2 cursor-pointer bg-white flex justify-between items-center"
    >
      <span className="text-gray-700">
        {selectedTourType ? selectedTourType.name : "Select Tour Type"}
      </span>
      <span className="text-gray-400">▼</span>
    </div>

    {/* Dropdown */}
    {isDropdownOpen && (
      <div className="absolute left-0 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-lg max-h-60 overflow-y-auto z-50">
        {tourType?.map((type) => (
          <div
            key={type?._id}
            onClick={() => {
              setSelectedTourType(type);
              setIsDropdownOpen(false);
              fetchTourNameById(type?._id)
            }}
            className="px-4 py-2 hover:bg-red-200 cursor-pointer text-gray-700"
          >
            {type?.name}
          </div>
        ))}
      </div>
    )}
  </div>
</div>
            {/* To Location */}
            <div className="lg:col-span-3" ref={tourNameDropdownRef}>
  <label className="block text-sm font-medium text-gray-600 mb-2">
    Tour Name
  </label>

  <div className="relative">

    {/* Selected Tour */}
    <div
      onClick={() => setIsTourNameDropdownOpen(!isTourNameDropdownOpen)}
      className="w-full border border-gray-300 rounded-xl px-4 py-2 cursor-pointer bg-white flex justify-between items-center"
    >
      <span className="text-gray-700">
        {selectedTourName ? selectedTourName.name : "Select Tour"}
      </span>

      <span className="text-gray-400">▼</span>
    </div>

    {/* Dropdown */}
    {isTourNameDropdownOpen && (
      <div className="absolute left-0 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-lg max-h-60 overflow-y-auto z-50">

        {tourNameById?.map((tour) => (
          <div
            key={tour?._id}
            onClick={() => {
              setSelectedTourName(tour);
              setIsTourNameDropdownOpen(false);
            }}
            className="px-4 py-2 hover:bg-red-200 cursor-pointer text-gray-700"
          >
            {tour?.name}
          </div>
        ))}

      </div>
    )}

  </div>
</div>
            

            {/* Departure Date */}
           <div className="lg:col-span-2" ref={travellersRef}>
  <label className="block text-sm font-medium text-gray-600 mb-2">
    Travellers
  </label>

  <div className="relative">

    {/* Input Box */}
    <div
      onClick={() => setTravellersOpen(!travellersOpen)}
      className="w-full border border-gray-300 rounded-xl px-4 py-2 cursor-pointer bg-white flex justify-between items-center"
    >
      <span>
        {adults + children} Traveller{adults + children > 1 && "s"}
      </span>

      <span className="text-gray-400">▼</span>
    </div>

    {/* Dropdown */}
    {travellersOpen && (
      <div className="absolute left-0 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-lg p-4 space-y-4 z-50">

        {/* Adults */}
        <div className="flex justify-between items-center">
          <span className="text-gray-700">Adults</span>

          <div className="flex items-center gap-3">

            <button
              onClick={() => adults > 1 && setAdults(adults - 1)}
              className="w-7 h-7 border rounded flex items-center justify-center"
            >
              -
            </button>

            <span>{adults}</span>

            <button
              onClick={() => setAdults(adults + 1)}
              className="w-7 h-7 border rounded flex items-center justify-center"
            >
              +
            </button>

          </div>
        </div>

        {/* Children */}
        <div className="flex justify-between items-center">
          <span className="text-gray-700">Children</span>

          <div className="flex items-center gap-3">

            <button
              onClick={() => children > 0 && setChildren(children - 1)}
              className="w-7 h-7 border rounded flex items-center justify-center"
            >
              -
            </button>

            <span>{children}</span>

            <button
              onClick={() => setChildren(children + 1)}
              className="w-7 h-7 border rounded flex items-center justify-center"
            >
              +
            </button>

          </div>
        </div>

      </div>
    )}

  </div>
</div>

            {/* Pickup Time */}
            <div className="lg:col-span-2">
              <label className="block text-sm font-medium text-gray-600 mb-2">
                Date
              </label>
              <input
                type="date"
                className="w-full px-4 py-2 text-[15px] font-semibold text-gray-900 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none"
              />
            </div>

            {/* Search Button */}
            <div className="lg:col-span-1">
              <button onClick={() => navigate(`/tour-details/${selectedTourName?._id}`)} className="w-full px-6 py-2 bg-red-500 hover:bg-white text-white hover:text-red-500 border border-red-500 duration-300 font-semibold text-[15px] rounded-xl transition-all shadow-lg hover:shadow-xl">
                Search
              </button>
            </div>
          </div>
          )}
       
      </div>
    </div>
  </div>
       
    
  );
};

export default HeroSection;

